import { render, staticRenderFns } from "./RealestateStep.vue?vue&type=template&id=28ab12ab&scoped=true&"
import script from "./RealestateStep.vue?vue&type=script&lang=js&"
export * from "./RealestateStep.vue?vue&type=script&lang=js&"
import style0 from "./RealestateStep.vue?vue&type=style&index=0&id=28ab12ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab12ab",
  null
  
)

export default component.exports